(function() {
  jQuery(document).ready(function() {
    jQuery(document).on("click", ".swell-share-referral-copy", function() {
      setTimeout(function(){
        detachReferralCopy();
        jQuery(".swell-referral-copy-link").html(jQuery(".swell-referral-copy-link").html().replace("http://",""));
        jQuery(".swell-referral-details").append(".");
      },20);
    });
    jQuery('body').on('click', '.swell-referral-back-link.checkout', function(e){
      jQuery(".vena-cbd-rewards").hide();
    });
    jQuery('body').on('click', '.swell-referral-back-link', function(e){
      jQuery(".swell-referral").removeClass("thankyou");
      jQuery(".swell-referral-sidebar-details").show();
    });
    jQuery(document).on("swell:referral:error", function(jqXHR, textStatus, errorThrown) {
        jQuery(".refer-customer-error").remove();
        jQuery(".swell-referral-sidebar-details").show();
        jQuery(".swell-referral").removeClass("thankyou");
        jQuery(".swell-referral-content-container").addClass("error-message");
        jQuery("#swell-referral-refer-emails").addClass("error-border");
      if(textStatus && textStatus === "EMAILS_ALREADY_PURCHASED"){
        jQuery(".swell-referral-form-body").prepend('<p class="refer-customer-error">Sorry! Looks like this person has already made a purchase. Try referring another friend.</p>');
      }
      else if(textStatus && textStatus === "Please enter a valid email address"){
        jQuery(".swell-referral-form-body").prepend('<p class="refer-customer-error">Please enter valid email addresses seperated with commas</p>');
      }
    });

    jQuery(document).on("swell:initialized", function() {
      var options = spapi.activeRedemptionOptions;
      for(var i=0;i<options.length;i++){
        if(options[i].discount_type == "shopify_recharge_fixed_amount"){
          if(jQuery(".swell-recharge-list").length>0){
            jQuery(".swell-recharge-list").append('<li class="swell-redeem swell-redemption-link" data-redemption-option-id="'+options[i].id+'"> <div class="price">$'+(options[i].discount_amount_cents/100)+'</div> <div class="points">'+options[i].amount+' Points</div> </li>');
          }
        }

        if(jQuery(".swell-cart.redemption-dropdown").length > 0 && options[i].discount_type == "cart_fixed_amount"){
          jQuery(".swell-cart.redemption-dropdown").append('<option value="'+options[i].id+'">$'+(options[i].discount_amount_cents/100)+' for '+options[i].amount+' Points</option>');
        }
      }
    });

    jQuery(document).on("swell:setup", function() {
      if(window.location.href.includes("my_rewards")){
        jQuery("body.account .page-width").css("margin-bottom","0");
      }
      jQuery(".spinner-icon").remove();

      if(jQuery(".campaigns").length>0){
        Swell.Campaign.initializeCampaigns(".campaigns", SwellConfig.Campaign.opts);
        SwellConfig.Campaign.authenticate();
        SwellConfig.Campaign.hideCreateAccountCampaign();
      }
      if(jQuery(".swell-tier-table").length>0){
        // SwellConfig.Tier.initializeDummyTier();
        SwellConfig.Tier.initializeCustomTierProperties();
        SwellConfig.Tier.initializeTiers(".swell-tier-table");
        setupSlickSlider();
      }

      if(jQuery(".swell-referral").length>0){
        SwellConfig.Referral.initializeReferral(".swell-referral");
        if(spapi.authenticated || (spapi.customer.referral_receipts && spapi.customer.referral_receipts.length > 0)) {
          setupReferrals();
        }
        jQuery(document).on("swell:referral:success", function(jqXHR, textStatus, errorThrown) {
          thankyou();
        });
        jQuery('body').on('click', '.swell-referral-copy', function(e){
          if(jQuery(e.target).hasClass("swell-referral-copy")) {
            e.stopPropagation();
          }
        });
        jQuery(".vena-cbd-rewards").css("display","flex");
      }

      // cart fixed amount functionality start
      jQuery('body').on('click', '.swell-redeem-cart.btn', function() {
        jQuery(".swell-redeem-cart.btn").html("<img class='spinner-icon-apply' src=//venacbd.com/cdn/shop/t/45/assets/swell-loader.svg?v=15457691556039571281662559963>");
        if(jQuery(".swell-cart.redemption-dropdown").val() == -1){
          spapi.$.confirm({
            title: "Oops!",
            content: "Please select a coupon to apply.",
            type: "red",
            typeAnimated: true,
            useBootstrap: false,
            boxWidth: "400px",
            buttons: {
              ok: {
                text: "Ok",
                action: function () {
                }
              }
            }
          });
          jQuery(".swell-redeem-cart.btn").html("APPLY");
          return;
        }
        if(spapi.authenticated){
          if(beforeDiscountRedemption()) {
            var redemptionOptionId = jQuery(".swell-cart.redemption-dropdown").val();
            redemptionOption = swellAPI.findActiveRedemptionOptionById(redemptionOptionId);
            if(redemptionOption.amount <= spapi.getAdjustedPointsBalance())
            {
              swellAPI.buyMultipleWithPoints([redemptionOption], function(){
                window.location = "/cart";
              });
            }
            else
            {
              spapi.$.confirm({
                title: "Oops!",
                content: "Sorry, you don't have enough points for this reward.",
                type: "red",
                typeAnimated: true,
                useBootstrap: false,
                boxWidth: "400px",
                buttons: {
                  ok: {
                    text: "Ok",
                    action: function () {
                    }
                  }
                }
              });
              jQuery(".swell-redeem-cart.btn").html("APPLY");
            }
          }
          else{
            jQuery(".swell-redeem-cart.btn").html("APPLY");
          }
        }
        else{
          jQuery(".swell-redeem-cart.btn").html("APPLY");
        }
      });

      Swell.Cart.items.forEach(function(item) {
        if (item.properties._swell_discount_type == "cart_fixed_amount") {
          redeemedRedemptionOption = swellAPI.findActiveRedemptionOptionById(item.properties._swell_redemption_option_id);
          jQuery(".swell-dropdown-row").before('<div class="content-row wow"> <div class="swell-discount-row row"> <div class="col-5 col-md-6 product-col"> <p class="text-small"> <strong>' + redeemedRedemptionOption.name + '</strong> </p> </div> <div class="col-4 col-md-3 qty-col"> <div class="line"> <input type="number" value="1" min="1" max="1" class="input text-small" disabled="disabled"> </div> <a href="javascript:void(0);" class="remove text-smaller hvr-bounce-to-right swell-coupon-remove" aria-label="Remove CBD Bites">Remove</a> </div> <div class="col-3 total-col"> <p class="text-small"> -' + redeemedRedemptionOption.cost_text + '</p> </div> </div> </div>');
          return
        }
      });

      jQuery('body').on('click',".swell-coupon-remove", function() {
        jQuery(".swell-coupon-remove").html("<img class='spinner-icon-remove' src=//venacbd.com/cdn/shop/t/45/assets/swell-loader.svg?v=15457691556039571281662559963>");
        swellAPI.removeRedemptionOptionIdFromCart(redeemedRedemptionOption.id, function(){
          window.location = "/cart";
        });
      });


      function beforeDiscountRedemption(){
        var redeemedItemsInCart = 0;
        var regularItemsInCart = 0;
        var discountInCart = 0;
        if(Swell.Cart && Swell.Cart.items){
          var cart = Swell.Cart;
          jQuery.each(cart.items, function(index, item){
            if(item.properties._swell_points_used){
              redeemedItemsInCart++;
            } else if(item.line_price > 0){
              regularItemsInCart++; 
            }
          });
          Swell.Cart.items.forEach(function(item) {
            if (item.properties._swell_discount_type == "cart_fixed_amount") {
              discountInCart++;
            }
          });
          if(discountInCart > 0) {
            spapi.$.confirm({
              title: "Oops!",
              content: "You already have a redeemed discount in your cart.",
              type: "red",
              typeAnimated: true,
              useBootstrap: false,
              boxWidth: "400px",
              buttons: {
                ok: {
                  text: "Ok",
                  action: function () {
                  }
                }
              }
            });
            return false;
          }
          else if(regularItemsInCart == 0) {
            spapi.$.confirm({
              title: "Oops!",
              content: "You must add a priced item in your cart to redeem points for a discount.",
              type: "red",
              typeAnimated: true,
              useBootstrap: false,
              boxWidth: "400px",
              buttons: {
                ok: {
                  text: "Ok",
                  action: function () {
                  }
                }
              }
            });
            return false;
          }
          else{
            return true;
          }
        }
      };
      // cart fixed amount functionality end

    });
  });
}).call(this);

(function() {
  window.SwellConfig = window.SwellConfig || {};
  SwellConfig.Campaign = {
    opts: {
      templates: {
        campaign: "<li class='swell-campaign' data-type='<%= campaign.type %>'> <div class='swell-campaign-content' data-display-mode='modal' data-campaign-id='<%= campaign.id %>'> <i class='swell-icon <%= campaign.icon %>'></span></i> <div class='swell-campaign-value'> <%= campaign.reward_text %> </div> <div class='swell-campaign-type'> <%= campaign.title %> </div> </div> </li>"
      }
    },
    authenticate: function() {
      jQuery(".campaigns-holder").addClass("loaded");
      jQuery(".campaigns").addClass("loaded");
      if (spapi.authenticated) {
        jQuery(".swell-campaign").css("cursor", "pointer");
      }
    },
    hideCreateAccountCampaign: function() {
      jQuery(".swell-campaign[data-type='CreateAccountCampaign']").remove();
    }
  };
}).call(this);


(function() {
  window.SwellConfig = window.SwellConfig || {};

  SwellConfig.Tier = {
    getCustomerTierRank: function() {
      
      var customer_tier, intro_tier, rank, tiers;
      customer_tier = spapi.customer.vip_tier;
      tiers = spapi.activeVipTiers;
      if (customer_tier && customer_tier.id) {
        rank = jQuery.grep(tiers, function(e) {
          return e.id === customer_tier.id;
        })[0].rank;
        return rank;
      } else {
        intro_tier = jQuery.grep(tiers, function(e) {
          return e.swellrequiredAmountSpent === "$0" && e.swellrequiredAmountSpentCents === 0 && e.swellrequiredPointsEarned === 0 && e.swellrequiredPurchasesMade === 0 && e.swellrequiredReferralsCompleted === 0;
        });
        if (intro_tier.length > 0) {
          return intro_tier[0].rank;
        } else {
          return null;
        }
      }
    },
    initializeDummyTier: function() {
      var k, len, tier, tiers;
      tiers = spapi.activeVipTiers;
      for (k = 0, len = tiers.length; k < len; k++) {
        tier = tiers[k];
        tier.rank += 1;
      }
      return tiers.unshift({
        id: -1,
        rank: 0,
        name: "SILVER",
        swellrequiredAmountSpentCents: 0,
        swellrequiredPointsEarned: 0,
        swellrequiredPurchasesMade: 0,
        swellrequiredReferralsCompleted: 0
      });
    },
    initializeCustomTierProperties: function() {
      spapi.activeVipTiers[0].points = "Create an Account",
      spapi.activeVipTiers[0].benefit_2 = "1x",
      spapi.activeVipTiers[0].benefit_3 = "100 points",
      spapi.activeVipTiers[0].benefit_4 = "<span class='blank'>.</span>",
      spapi.activeVipTiers[0].benefit_5 = "<span class='blank'>.</span>",
      spapi.activeVipTiers[0].benefit_6 = "<span class='blank'>.</span>",
      spapi.activeVipTiers[0].benefit_1 = "<span class='dot'>•</span>",

      spapi.activeVipTiers[1].points = "<span class='weighted'>Spend $"+(spapi.activeVipTiers[1].amount_spent_cents/100)+"-$"+((spapi.activeVipTiers[2].amount_spent_cents/100)-1)+"</span>or make<br>"+spapi.activeVipTiers[1].purchases_made + " purchases onsite",
      spapi.activeVipTiers[1].benefit_2 = spapi.activeVipTiers[1].points_multiplier.split(".")[0]+"x",
      spapi.activeVipTiers[1].benefit_3 = "100 points",
      spapi.activeVipTiers[1].benefit_4 = "<span class='dot'>•</span>",
      spapi.activeVipTiers[1].benefit_5 = "<span class='dot'>•</span>",
      spapi.activeVipTiers[1].benefit_6 = "<span class='blank'>.</span>",
      spapi.activeVipTiers[1].benefit_1 = "<span class='dot'>•</span>",

      spapi.activeVipTiers[2].points = "<span class='weighted'>Spend $"+(spapi.activeVipTiers[2].amount_spent_cents/100)+"+</span>or make<br>"+spapi.activeVipTiers[2].purchases_made+"+ purchases onsite",
      spapi.activeVipTiers[2].benefit_2 = spapi.activeVipTiers[2].points_multiplier.split(".")[0]+"x"  + "<div class='product-subscription'>*excludes subscription products</div>",
      spapi.activeVipTiers[2].benefit_3 = "200 points",
      spapi.activeVipTiers[2].benefit_4 = "<span class='dot'>•</span>",
      spapi.activeVipTiers[2].benefit_5 = "<span class='dot'>•</span>",
      spapi.activeVipTiers[2].benefit_6 = "<span class='dot'>•</span>",
      spapi.activeVipTiers[2].benefit_1 = "<span class='dot'>•</span>";
    },
    initializeTiers: function(containerSelector) {
      if (jQuery(containerSelector).length === 0) {
        return "";
      }
      tiers = spapi.activeVipTiers;
      var next_info = "";
      customer_tier_rank = SwellConfig.Tier.getCustomerTierRank();
      if(customer_tier_rank == null){
        customer_tier_rank = 0;
      }
      for(var t=0;t<tiers.length;t++)
      {
        if(t==customer_tier_rank && spapi.authenticated){
          tiers[t].current_status="<span class='current-status-item'>Current Status</span>";
        }
        else{
          tiers[t].current_status="";
        }
      }
      jQuery(containerSelector).append("<div class='titles-col'><span class='name-item'>BENEFITS</span><span class='benefit-item benefit-item-2'>Point multiplier</span><span class='benefit-item benefit-item-3'>Birthday points multiplier</span><span class='benefit-item benefit-item-4'>Swag/freebies</span><span class='benefit-item benefit-item-5'>Early access to new products</span><span class='benefit-item benefit-item-6'>Early access to new sales and promotions</span></div>");
      jQuery(containerSelector).append("<div class='tier-holder'></div>");
      var check = true;
      for(var t=0;t<tiers.length;t++)
      {
        if((customer_tier_rank==null || t==customer_tier_rank) && spapi.authenticated)
        {
          if(t<2){
            if(spapi.customer.vip_tier_stats != undefined){
              var amount = (tiers[t+1].amount_spent_cents-spapi.customer.vip_tier_stats.amount_spent_cents)/100;
              if(amount < 0){
                amount = 0;
              }
              next_info = "Spend $"+amount+" more to earn "+tiers[t+1].name+" tier";
            }
          }
          if(customer_tier_rank==null && check){
            if(spapi.customer.vip_tier_stats != undefined){
              var amount = (tiers[t].amount_spent_cents-spapi.customer.vip_tier_stats.amount_spent_cents)/100;
              if(amount < 0){
                amount = 0;
              }
              next_info = "Spend $"+amount+" more to earn "+tiers[t].name+" tier";
            }
            jQuery(".tier-holder").append("<div class='tier-"+(t+1)+"-col active'><span class='next-info-item'>"+next_info+"</span><span class='name-item'>"+tiers[t].name+"</span><span class='points-item'>"+tiers[t].points+"</span><span class='benefit-item benefit-item-2'>"+tiers[t].benefit_2+"</span><span class='benefit-item benefit-item-3'>"+tiers[t].benefit_3+"</span><span class='benefit-item benefit-item-4'>"+tiers[t].benefit_4+"</span><span class='benefit-item benefit-item-5'>"+tiers[t].benefit_5+"</span><span class='benefit-item benefit-item-6'>"+tiers[t].benefit_6+"</span></div>");
            next_info = "";
            check = false;
          }
          else{
            jQuery(".tier-holder").append("<div class='tier-"+(t+1)+"-col active'><span class='name-item'>"+tiers[t].current_status+tiers[t].name+"</span><span class='points-item'>"+tiers[t].points+"</span><span class='benefit-item benefit-item-2'>"+tiers[t].benefit_2+"</span><span class='benefit-item benefit-item-3'>"+tiers[t].benefit_3+"</span><span class='benefit-item benefit-item-4'>"+tiers[t].benefit_4+"</span><span class='benefit-item benefit-item-5'>"+tiers[t].benefit_5+"</span><span class='benefit-item benefit-item-6'>"+tiers[t].benefit_6+"</span></div>");
          }
        }
        else
        {
          jQuery(".tier-holder").append("<div class='tier-"+(t+1)+"-col'><span class='next-info-item'>"+next_info+"</span><span class='name-item'>"+tiers[t].name+"</span><span class='points-item'>"+tiers[t].points+"</span><span class='benefit-item benefit-item-2'>"+tiers[t].benefit_2+"</span><span class='benefit-item benefit-item-3'>"+tiers[t].benefit_3+"</span><span class='benefit-item benefit-item-4'>"+tiers[t].benefit_4+"</span><span class='benefit-item benefit-item-5'>"+tiers[t].benefit_5+"</span><span class='benefit-item benefit-item-6'>"+tiers[t].benefit_6+"</span></div>");
          next_info = "";
        }
      }
    }
  }
}).call(this);

function setupSlickSlider(){
  jQuery('.swell-tier-table .tier-holder').slick({
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 1,
    nextArrow: null,
    prevArrow: null,
    dots: true,
    arrows: false,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      }
    ]
  });
  if(jQuery(window).width()<768){
    jQuery('.swell-tier-table .tier-holder').slick("slickGoTo",SwellConfig.Tier.getCustomerTierRank()==null ? 0:SwellConfig.Tier.getCustomerTierRank());
  }
}

// referral
(function() {
  window.SwellConfig = window.SwellConfig || {};

  SwellConfig.Referral = {
    opts: {
      localization: {
        referralSidebarDetailsAction: "REFER A FRIEND",
        referralSidebarDetailsReward: "",

        referralRegisterHeading: "GIVE $20, GET $20",
        referralRegisterFormDetails: "Enter your email to get started.",
        referralRegisterFormEmail: "Your email...",
        referralRegisterFormSubmit: "NEXT",
        referralRegisterDetails: "<%= referralCampaign.details %>",

        referralReferHeading: "GIVE $20, GET $20",
        referralReferFormEmails: "Your friends’ emails (separated by commas)",
        referralReferFormSubmit: "SEND",
        referralReferFormDetails: "Now, enter your friends’ emails.",
        referralReferFormEmailsDetails: "",
        referralReferDetails: "<%= referralCampaign.details %>",

        referralReferMediaDetails: "You can also share the link with the button below.",

        referralShareFacebook: "Share",
        referralShareCopy: "Copy Link",
        referralShareSMS: "SMS",
        referralShareMessenger: "Message",

        referralFacebookIcon: "swell-icon-fb",
        referralLinkIcon: "swell-icon-copy",
        referralSMSIcon: "swell-icon-sms",
        referralMessengerIcon: "swell-icon-message",

        referralThanksHeading: "Thanks for Referring!",
        referralThanksDetails: "Remind your friends to check their emails.",

        referralCopyHeading: "Copy Link",
        referralCopyButton: "Copy Link",
        referralCopyDetails: "Copy link and share with your friends"
      },
      templates: {
        referralRegister: '<div class="swell-referral-register"> <h2 class="swell-referral-heading"><%= localization.referralRegisterHeading %></h2> <div class="swell-referral-details-container"><p class="swell-referral-details"><%= localization.referralRegisterDetails %></p></div><div class="middle-border"></div><div class="swell-referral-form-wrapper"> <form name="swell-referral-register-form" class="swell-referral-form" id="swell-referral-register-form" method="POST" action="."> <div class="swell-referral-form-header"> <p class="swell-referral-form-header-details"><%= localization.referralRegisterFormDetails %></p> </div> <div class="swell-referral-form-body"> <ul class="swell-referral-form-list"> <li class="swell-referral-form-list-field"> <input class="swell-referral-form-list-field-input" type="email" name="swell-referral-register-email" id="swell-referral-register-email" required="required" placeholder="<%= localization.referralRegisterFormEmail %>"> </li> <li class="swell-referral-form-list-button"> <div class="swell-referral-form-footer"> <input class="swell-referral-form-list-submit" type="submit" name="swell-referral-register-submit" id="swell-referral-register-submit" value="<%= localization.referralRegisterFormSubmit %>"> </div> </li> </ul> </div> </form> </div> </div>',
        referralRefer: '<div class="swell-referral-refer"> <h2 class="swell-referral-heading"><%= localization.referralReferHeading %></h2> <div class="swell-referral-details-container"><p class="swell-referral-details"><%= localization.referralReferDetails %></p></div><div class="middle-border"></div><div class="swell-referral-form-wrapper"> <form class="swell-referral-form" name="swell-referral-refer-form" id="swell-referral-refer-form" method="POST" action="."> <div class="swell-referral-form-header"> <p class="swell-referral-form-header-details"><%= localization.referralReferFormDetails %></p> </div> <div class="swell-referral-form-body"> <ul class="swell-referral-form-list"> <li class="swell-referral-form-list-field"> <input class="swell-referral-form-list-field-input" type="text" name="swell-referral-refer-emails" id="swell-referral-refer-emails" required="required" placeholder="<%= localization.referralReferFormEmails %>"> </li> <li class="swell-referral-form-list-button"> <input class="swell-referral-form-list-submit" type="submit" name="swell-referral-refer-submit" id="swell-referral-refer-submit" value="<%= localization.referralReferFormSubmit %>"> </li> </ul> </div> </form> </div> <div class="swell-referral-media-wrapper"> <p class="swell-referral-media-details"><%= localization.referralReferMediaDetails %></p> <ul class="swell-referral-media-list"> <li class="swell-referral-medium swell-share-referral-facebook"> <div class="swell-referral-medium-content"> <i class="swell-referral-media-icon <%= localization.referralFacebookIcon %>" aria-hidden="true"></i><%= localization.referralShareFacebook %> </div> </li> <li class="swell-referral-medium swell-share-referral-sms"> <div class="swell-referral-medium-content"> <i class="swell-referral-media-icon swell-icon-sms" aria-hidden="true"></i>SMS</div> </li> <li class=\"swell-referral-medium swell-share-referral-twitter\"> <div class="swell-referral-medium-content"> <i class=\"swell-icon-tweet-mob\" aria-hidden=\"true\"></i>Tweet</div> </li> <li class="swell-referral-medium swell-share-referral-messenger"> <div class="swell-referral-medium-content"> <i class="swell-referral-media-icon <%= localization.referralMessengerIcon %>" aria-hidden="true"></i><%= localization.referralShareMessenger %></div> </li> <li class="swell-referral-medium swell-share-referral-copy"> <div class="swell-referral-medium-content"> <i class="swell-referral-media-icon <%= localization.referralLinkIcon %>" aria-hidden="true"></i><%= localization.referralShareCopy %></div> </li> </ul> </div> </div>',
        referralCopy: '<div class="swell-referral-copy"> <div class="swell-referral-copy-content"> <div class="swell-referral-copy-main"> <span class="swell-referral-back-link"></span> <h2 class="swell-referral-heading"> </h2> <div class="swell-referral-form-wrapper"> <div class="swell-referral-link swell-referral-copy-link" id="swell-referral-copy-link"></div> <button class="swell-referral-copy-button" id="swell-referral-copy-button" data-clipboard-target="#swell-referral-copy-link"><%= localization.referralCopyHeading %><i class="swell-icon-right"></i></button> <p class="swell-referral-details"><%= localization.referralCopyDetails%></p> </div> </div> </div> </div>'
      }
    },
    initializeReferral: function(containerSelector) {
      var email = jQuery(containerSelector).data("customer-email");
      if (email) {
        spapi.storage.setItem("referrer_email", email);
        spapi.customer.email = email;
      }
      Swell.Referral.initializeReferral(".swell-referral", SwellConfig.Referral.opts);
      jQuery(".swell-referral").show();
    }
  };
}).call(this);

function setupReferrals(){
  jQuery(".swell-referral-content").show();
  jQuery(".border").show();
  if(spapi.customer.referral_receipts.length > 0) {
    jQuery(".referral-table").show();
    referrals = spapi.customer.referral_receipts;

    referrals.forEach(function(referral) {
      status = null;

      if(referral.completed_at){ 
        status = "Purchased ("+spapi.activeReferralCampaign.prettyReward+" earned)";
      } else {
        status = "Invited";
      }

      jQuery(".swell-referral-table tbody").append('<tr> <td> <div class="trucate-email">' +  referral.email + '</div></td><td>' + status +'</td></tr>');
    });  
  }
}

function detachReferralCopy(){
  if(jQuery(".swell-referral-copy").length > 0){
    jQuery("body").append(jQuery(".swell-referral-copy").detach());
  }
}

function thankyou(){
  jQuery(".swell-referral-sidebar-details").hide();
  jQuery(".swell-referral").addClass("thankyou");
  swellAPI.refreshCustomerDetails(function(){
    jQuery(".swell-referral-table tbody").html("");
    referrals = spapi.customer.referral_receipts;
    referrals.forEach(function(referral) {
      status = null;

      if(referral.completed_at){ 
        status = "Purchased ("+spapi.activeReferralCampaign.prettyReward+" earned)";
      } else {
        status = "Invited";
      }

      jQuery(".swell-referral-table tbody").append('<tr> <td> <div class="trucate-email">' +  referral.email + '</div></td><td>' + status +'</td></tr>');
    });
  });
}
